import { useinsertdata, useinsertdatawithoutimage } from '../../Hooks/usePostData';
import {
  Add_Sales,
  Delete_One_Sales,
  Get_All_Managers,
  Get_All_Sales,
  Get_All_Sales_By_Managers_Email_Type,
  Get_All_Sales_By_TeamLeader_Email,
  Get_All_Sales_For_Team_Leader_And_Teir_Leads,
  Get_All_Sales_Trash_type,
  Get_All_TeamLeaders_For_Managers_By_Email,
  Get_All_Top_Saler_by_Quarter,
  Get_Error,
  Get_One_Sales,
  Get_Sales_login_For_Assign_Leads_To_TeamLeaders_type,
  Update_One_Sales,
} from '../Types';
import usegetdata from '../../Hooks/useGetData';
import usedeletedata from '../../Hooks/useDeleteData';
import { UpdateProductdata } from '../../Hooks/useUpdateData';

//insert all cities data
export const Add_Sales_Action = (body) => async (dispatch) => {
  try {
    const res = await useinsertdatawithoutimage(`/api/v1/Sales`, body);

    dispatch({
      type: Add_Sales,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//insert all cities data
export const Add_Sales_Action_From_Excell = (body) => async (dispatch) => {
  try {
    const res = await useinsertdata(`/api/v1/Sales`, body);

    dispatch({
      type: Add_Sales_Action_From_Excell,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all cities data
export const Get_All_Sales_Action = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Sales?salesisactivate=true`);

    dispatch({
      type: Get_All_Sales,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all sales data not active
export const Get_All_Sales_Action_not_active = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Sales?salesisactivate=false`);

    dispatch({
      type: Get_All_Sales_Trash_type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all cities data
export const Get_one_Sales_Action = (id) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Sales/${id}`);

    dispatch({
      type: Get_One_Sales,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//delete all cities data
export const Delete_One_Sales_Action = (id) => async (dispatch) => {
  try {
    const res = await usedeletedata(`/api/v1/Sales/${id}`);

    dispatch({
      type: Delete_One_Sales,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//Update all cities data
export const Update_one_Sales_Action = (id, body) => async (dispatch) => {
  try {
    const res = await UpdateProductdata(`/api/v1/Sales/${id}`, body);

    dispatch({
      type: Update_One_Sales,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all TeamLeaders data
export const Get_All_Sales_By_TeamLeader_Email_Action = (email) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Sales/salesbyemail?email=${email}`);

    dispatch({
      type: Get_All_Sales_By_TeamLeader_Email,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all TeamLeaders data
export const Get_All_Sales_By_Managers_Email_Action = (email) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Sales/salesbymanagersemail?email=${email}`);

    dispatch({
      type: Get_All_Sales_By_Managers_Email_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all TeamLeaders and sales that related with manager
export const Get_All_TeamLeaders_and_Sales__By_Managers_Email_Action =
  (email) => async (dispatch) => {
    try {
      const res = await usegetdata(`/api/v1/Sales/TeamLeadersbymanagersemail?email=${email}`);

      dispatch({
        type: Get_All_TeamLeaders_For_Managers_By_Email,
        payload: res,
      });
    } catch (e) {
      dispatch({
        type: Get_Error,
        payload: e.res,
      });
    }
  };

//get all TeamLeaders and sales that related with manager
export const Get_All_Managers_Action = (email) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Sales/managers`);

    dispatch({
      type: Get_All_Managers,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all top saler by quarter
export const Get_All_Top_Saller_By_Quarter_Action = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/users/sales-performance-Quarter`);

    dispatch({
      type: Get_All_Top_Saler_by_Quarter,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

// get all sales for selected team leader and leads data for sales stages and leads for analytics

export const Get_All_sales_For_Team_Leader_Selected_and_Stages_and_Leads =
  (email) => async (dispatch) => {
    try {
      const res = await usegetdata(
        `/api/v1/users/Get_Sales_Data_And_Thier_Leads_Data?email=${email}`,
      );

      dispatch({
        type: Get_All_Sales_For_Team_Leader_And_Teir_Leads,
        payload: res,
      });
    } catch (e) {
      dispatch({
        type: Get_Error,
        payload: e.res,
      });
    }
  };

export const Get_sales_Login_For_Assign_Leads_To_histeamleader_Action =
  (leadIds, clearHistory = false) =>
  async (dispatch) => {
    try {
      const res = await UpdateProductdata('/api/V1/Sales/sales-by-email', {
        leadIds,
        clearHistory,
      });

      dispatch({
        type: Get_Sales_login_For_Assign_Leads_To_TeamLeaders_type,
        payload: res,
      });
    } catch (e) {
      dispatch({
        type: Get_Error,
        payload: e.res,
      });
    }
  };
